
import { Users, Shield, Briefcase } from "lucide-react";

const howItWorks = [
  {
    title: "Create Your Profile",
    description: "Sign up and create your professional profile in minutes",
    icon: <Users className="w-12 h-12 text-emerald-500" />,
    step: "01",
  },
  {
    title: "Connect Wallet",
    description: "Link your crypto wallet to receive DGK payments",
    icon: <Shield className="w-12 h-12 text-emerald-500" />,
    step: "02",
  },
  {
    title: "Start Working",
    description: "Find projects or post jobs and begin collaborating",
    icon: <Briefcase className="w-12 h-12 text-emerald-500" />,
    step: "03",
  },
];

// const howItWorks = [
//   {
//     title: "Create a Profile",
//     description: "Highlight your expertise and experience.",
//     icon: <Users className="w-12 h-12 text-emerald-500" />,
//     step: "01",
//   },
//   {
//     title: "Apply to Jobs",
//     description: "Find matching jobs and submit proposals directly.",
//     icon: <Shield className="w-12 h-12 text-emerald-500" />,
//     step: "02",
//   },
//   {
//     title: "Deliver Results",
//     description: "Work securely with clients through the platform.",
//     icon: <Briefcase className="w-12 h-12 text-emerald-500" />,
//     step: "03",
//   },
//   {
//     title: "Get Paid",
//     description: "Receive payments quickly and safely.",
//     icon: <Briefcase className="w-12 h-12 text-emerald-500" />,
//     step: "04",
//   },
// ];

export const HowItWorksSection = () => {
  return (
    <section className="container mx-auto px-4 py-24">
      <div className="relative">
        {/* Background decoration */}
        <div className="absolute inset-0 bg-gradient-to-b from-white to-emerald-50/30" />
        
        <div className="relative">
          <h2 className="text-4xl font-bold text-center mb-16 text-gray-900 animate-fade-in">
            How DGK Freelance Hub Works
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
            {howItWorks.map((item, index) => (
              <div 
                key={index} 
                className="relative animate-fade-in"
                style={{ animationDelay: `${index * 200}ms` }}
              >
                <span className="absolute -top-8 left-0 text-8xl font-bold text-gray-100 select-none">
                  {item.step}
                </span>
                <div className="relative z-10 flex flex-col items-center text-center group">
                  <div className="p-4 bg-white rounded-2xl shadow-lg mb-6 transform transition-all duration-300 group-hover:scale-110 group-hover:shadow-xl">
                    {item.icon}
                  </div>
                  <h3 className="text-2xl font-semibold mt-6 mb-3">{item.title}</h3>
                  <p className="text-gray-600">{item.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
